// The Pulse HTTP wire contract (Slice 6; slice-plan.md:83-92; D27; ADR-0023).
//
// The SINGLE source of truth for the Pulse route apps/api (producer) and apps/web (consumer)
// build against. Success payload is the domain schema from ../model/pulse.js; every failure
// returns the shared `ErrorEnvelope { code, message }` (http/knowledge.ts:21) - a byte-identical
// not-found on an app that is not the caller's (app-security §2 A01).
import { z } from "zod";
import { AppId } from "../ids.js";
import { PulseView } from "../model/pulse.js";
/** The canonical route path string, for the api lane to register verbatim (D2). */
export const PULSE_ROUTES = {
    pulse: "/v1/apps/:appId/pulse",
};
/** Path params for the app-scoped Pulse route: the one app the request is scoped to. */
export const PulseRouteParams = z.object({ appId: AppId });
// --- Pulse: GET /v1/apps/:appId/pulse (the seven founder metrics, D27 wall) ---
/** 200 -> the `PulseView` (the seven founder metrics, no cost surface), else an `ErrorEnvelope`. */
export const PulseResponse = PulseView;
//# sourceMappingURL=pulse.js.map